import type { Category } from "../hooks/useCategories.ts";
import { CategoryCard } from "./CategoryCard.tsx";

export function CategoryGrid({ categories }: { categories: Category[] }) {
  return (
    <div className="grid gap-px sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {categories.map((c) => (
        <CategoryCard key={c.id} category={c} />
      ))}
    </div>
  );
}
